import axios from 'axios';
import { rawreq,req } from './axiosFun';

// 统计分析 查询科目报表数据
export const querySubjectReport = (params) => { return rawreq("post", "/api/report/querySubjectReport", params) };

// 统计分析 查询地区报表数据
export const queryAreaTreeReport = (params) => { return rawreq("post", "/api/report/queryAreaTreeReport", params) };

// 统计分析 查询年龄报表数据
export const queryAgeReport = (params) => { return rawreq("post", "/api/report/queryAgeReport", params) };

// 统计分析 查询营销渠道报表数据
export const queryMarketingChannelReport = (params) => { return rawreq("post", "/api/report/queryMarketingChannelReport", params) };



// WEBPACK FOOTER //
// ./src/api/report.js